<template>
    <div class="filter-container">
        <div class="field-column field-column__xlarge">
            <div class="field-container">
                <span class="field-label">Device Status</span>
                <v-select v-model="filter.active" :options="ACTIVE_OPTIONS" :clearable="false" label="name">
                </v-select>
            </div>
        </div>
        <div class="field-column field-column__xlarge">
            <div class="field-container">
                <span class="field-label">Device Location</span>
                <v-select v-model="filter.location" :options="sortedLocations" :clearable="false" label="name">
                </v-select>
            </div>
        </div>
        <div class="field-column field-column__xlarge">
            <div class="field-container">
                <span class="field-label">Device Country</span>
                <v-select v-model="filter.country" :options="sortedCountries" :clearable="false" label="name">
                </v-select>
            </div>
        </div>
        <div class="field-column field-column__large">
            <div class="field-container">
                <span class="field-label">Device Type</span>
                <v-select v-model="filter.type" :options="TYPE_OPTIONS" :clearable="false" label="name">
                </v-select>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineModel } from "@hublot-io/define-model";
import { computed, defineProps } from "vue";

const ALL_OPTION = {
    name: "All",
    id: "all",
    display: "All",
};

const ACTIVE_OPTIONS = [
    ALL_OPTION,
    { name: "Active", id: "active" },
    { name: "Inactive", id: "inactive" },
];

const TYPE_OPTIONS = [
    ALL_OPTION,
    { name: "XCube", id: "xcube" },
    { name: "XPod", id: "xpod" },
    { name: "Kiosk", id: "xkiosk" },
    { name: "Xtend", id: "xtend" },
];

const props = defineProps({
    locations: {
        type: Array,
        default: () => [],
    },
});

const filter = defineModel();

const sortedLocations = computed(() => {
    return [ALL_OPTION].concat([...props.locations].sort((a, b) => a.name.localeCompare(b.name)));
});

const sortedCountries = computed(() => {
    const countriesSet = props.locations.reduce((set, location) => {
        if (location.country) {
            set.add(location.country.toUpperCase());
        }
        return set;
    }, new Set());
    const countriesArray = Array.from(countriesSet).map((country) => ({ name: country, id: country }));
    countriesArray.sort((a, b) => a.name.localeCompare(b.name));
    return [ALL_OPTION].concat(countriesArray);
});

</script>

<style lang="scss">
@use "../colors" as *;

.filter-container {
    display: flex;
    justify-content: flex-start;
    background-color: rgba($color-background, 0.71);
    flex-wrap: wrap;
    border: 1px solid $color-primary;
    border-radius: 0.5rem;
    align-items: center;
    padding: 0.5rem;
    margin-bottom: 1rem;
}

.vs__search {
    min-width: 100px;
}

.field-column {
    flex-basis: 250px;
    min-width: 200px;
    max-width: 300px;

    &__large {
        flex-basis: 400px;
        min-width: 300px;
        max-width: 500px;

        .vs__dropdown-menu {
            min-width: 300px;
        }
    }

    &__xlarge {
        flex-basis: 500px;
        min-width: 400px;
        max-width: 600px;

        .vs__dropdown-menu {
            min-width: 400px;
        }
    }
}

.field-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    padding: 0.5rem;

    .field-label {
        width: 75px;
        padding-right: 1rem;
        text-align: right;

        &__large {
            width: 175px;
        }
    }
}
</style>